<script>
import diets from '@/assets/diets-options'

export default {
  name: 'ProductItem',
  props: {
    product: { type: Object, required: true },
    quantity: { type: Number, default: 0 }
  },
  computed: {
    tags() {
      if (!this.product) return
      const { map } = this.lodash

      const tags = map(this.product.tags, tag => {
        const diet = diets.find(
          x => x.value === tag && ['VEGAN', 'VEGETARIAN'].indexOf(x.value) > -1
        )
        if (diet) return { text: diet.tag, color: 'light-green' }
        return null
      }).filter(x => x)

      if (this.product.left - this.quantity <= 5) {
        tags.unshift({
          text: `${this.product.left - this.quantity} left`,
          color: 'accent'
        })
      }

      return tags
    }
  }
}
</script>

<template>
  <!-- Product item -->
  <v-card flat>
    <!-- Product photo -->
    <v-list-item-avatar color="grey lighten-3" size="100%">
      <v-img
        class="product-photo"
        :src="product.photo"
        :lazy-src="product.photo"
        eager
        contain
      />

      <v-badge v-if="quantity > 0" overlap color="primary">
        <template v-slot:badge>
          <span>{{ quantity }}</span>
        </template>
      </v-badge>

      <div class="item-tags">
        <v-chip
          v-for="(tag, i) in tags"
          :key="i"
          :color="tag.color"
          text-color="white"
          class="mr-1 text-uppercase"
          x-small
        >
          {{ tag.text }}
        </v-chip>
      </div>
    </v-list-item-avatar>

    <v-list-item-content>
      <!-- Product name -->
      <v-list-item-title class="subtitle-2 font-weight-bold">
        {{ product.name }}
      </v-list-item-title>
      <v-list-item-subtitle class="body-2 secondary--text">
        <!-- {{ product.currencyCode }} -->
        RM {{ product.price }}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-card>
</template>

<style scoped lang="sass">
.v-chip
  padding-right: 3px !important
  padding-left: 3px !important

.v-list-item__content
  padding: 0 0 1px

.v-avatar, .product-photo
  border-radius: 4px

.v-badge
  display: flex
  position: absolute
  bottom: 16px
  left: 16px

.item-tags
  position: absolute
  top: 2px
  right: 1px
</style>
